// Default brand fit prompt set per gender. Used by the contextual brand-fit
// re-prompt on PurchaseConfidenceCard.

import type { Gender } from "@/lib/guestReasoningTemplates";
import { normaliseBrand } from "@/lib/brandRegistry";

const DEFAULTS: Record<"women" | "men" | "non-binary", string[]> = {
  women: ["Zara", "ASOS", "H&M", "& Other Stories"],
  men: ["Zara", "ASOS", "H&M", "Next"],
  "non-binary": ["Zara", "ASOS", "H&M", "COS"],
};

export function isInDefaultBrands(
  brand: string | null,
  gender: Gender | null,
): boolean {
  if (!brand) return false;
  const g: "women" | "men" | "non-binary" =
    gender === "men" || gender === "non-binary" ? gender : "women";
  const normalisedBrand = normaliseBrand(brand);
  if (!normalisedBrand) return false;
  return DEFAULTS[g].some(
    (b) => normaliseBrand(b) === normalisedBrand,
  );
}

export const DISMISS_ALL_SENTINEL = "__all__";
